import type { FeatureFlags } from 'shared/api/containerApi/requests/getFeatureFlags'

// Remotes wait at most this long for the first flags fetch (no cache yet).
const READY_TIMEOUT_MS = 3_000

let resolveReady: (() => void) | null = null

const createReadyPromise = () =>
  new Promise<void>(resolve => {
    resolveReady = resolve
    setTimeout(() => {
      if (resolveReady !== resolve) return
      // Intentional: tells developers why flags are off.
      // eslint-disable-next-line no-console
      console.error(
        `[feature-flags] Not loaded within ${READY_TIMEOUT_MS}ms, apps start with all feature flags inactive.`
      )
      resolveReady = null
      resolve()
    }, READY_TIMEOUT_MS)
  })

let ready = createReadyPromise()

/**
 * Publishes flags to the global that `featureFlags` from
 * @inno-tools/container-bridge reads, and releases remotes waiting in
 * `whenFeatureFlagsReady`.
 */
export const setFeatureFlags = (flags: FeatureFlags) => {
  window.__CONTAINER_FEATURE_FLAGS__ = flags
  resolveReady?.()
  resolveReady = null
}

/** Makes remotes wait again, e.g. after logging in without a page reload. */
export const resetFeatureFlags = () => {
  if (resolveReady) return
  ready = createReadyPromise()
}

/** Resolves once flags are set, or after the timeout. Never rejects. */
export const whenFeatureFlagsReady = () => ready
